export const StyledSubHeader = ({heading, color = 'purple'}:{heading: string, color?: string})=>{

    return(
        <div className='flex-row' style={{justifyContent:'flex-start', alignItems:'center', width:'100%' }} >
            <div style={{width: 10, height: 20, backgroundColor: color}} />
            <div style={{width: 5}} ></div>
            <h3>{heading}</h3>
        </div>
    )
}